export default __webpack_public_path__ + "static/media/flower_field.51f872cf.jpg";